import { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { useField } from 'formik'
import { Label } from '../../shared/styled_components/label'

export const FormikInput = ({
  label,
  styles,
  inputClassName,
  dataTip,
  tooltipId,
  noMargin = false,
  size,
  type,
  dataTestId,
  ...props
}) => {
  const [field, meta] = useField(props)
  const [focus, setFocus] = useState(false)

  const handleFocus = () => {
    setFocus(true)
  }
  const customBlur = (e) => {
    field.onBlur(e)
    if (props.onBlur) {
      props.onBlur(e)
    }
    setFocus(false)
  }
  const customChange = (e) => {
    field.onChange(e)
    if (props.onChange) {
      props.onChange(e)
    }
  }

  return (
    <Label
      $focus={focus}
      $styles={styles}
      data-tooltip-id={tooltipId}
      data-tooltip-content={dataTip}
      $noMargin={noMargin}
      $size={size}
      data-testid={dataTestId}
    >
      {label && <span>{label}</span>}
      {inputClassName === 'rate' && (
        <InputWrapper>
          <input
            className={(meta.touched && meta.error ? 'error' : '') + (inputClassName ? ' ' + inputClassName : '')}
            {...field}
            {...props}
            onFocus={handleFocus}
            onBlur={customBlur}
            onChange={customChange}
          />
        </InputWrapper>
      )}
      {(!inputClassName || inputClassName !== 'rate') && type !== 'textarea' && (
        <input
          className={(meta.touched && meta.error ? 'error' : '') + (inputClassName ? ' ' + inputClassName : '')}
          {...field}
          {...props}
          onFocus={handleFocus}
          onBlur={customBlur}
          onChange={customChange}
        />
      )}
      {(!inputClassName || inputClassName !== 'rate') && type === 'textarea' && (
        <textarea
          className={(meta.touched && meta.error ? 'error' : '') + (inputClassName ? ' ' + inputClassName : '')}
          {...field}
          {...props}
          onFocus={handleFocus}
          onBlur={customBlur}
          onChange={customChange}
        />
      )}
      {meta.touched && meta.error ? <div className="error">{meta.error}</div> : null}
    </Label>
  )
}

FormikInput.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  styles: PropTypes.object,
  inputClassName: PropTypes.string,
  noMargin: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  dataTip: PropTypes.string,
  tooltipId: PropTypes.string,
  type: PropTypes.string,
  dataTestId: PropTypes.string
}

const InputWrapper = styled.div`
  &::after {
    content: '%';
    font-weight: 400;
    right: 2px;
    bottom: 8px;
    position: absolute;
    color: #333333;
  }
`
